module.exports = __webpack_public_path__ + "img/headline01.2fa4e98b.jpg";